<!--
  Delete Dynamic Field confirmation.
  Figma: Settings - Delete Dynamic Field (confirmation) 141:537 / dialog 143:537.
-->
<div class="delete-field-dialog">
  <div class="dialog-header">
    <div class="close-icon" role="button" tabindex="0" aria-label="Close"
      (click)="onCancel()" (keydown.enter)="onCancel(); $event.preventDefault()"
      (keydown.space)="onCancel(); $event.preventDefault()">
      <span aria-hidden="true">&times;</span>
    </div>
  </div>

  <div class="dialog-content">
    <div class="dialog-message lato-16-b-vw txt-clr">
      Please note you are about to delete the
      <span class="field-name">{{ field?.label }}</span> dynamic field.
    </div>

    <div class="mode-options" role="radiogroup" aria-label="Delete scope">
      <label class="mode-option">
        <input type="radio" name="deleteMode" [value]="deleteModes.ALL_RISKS"
          [(ngModel)]="mode" />
        <span class="mode-text">
          <span class="mode-title lato-14-n-vw txt-clr">Delete from all risks</span>
          <span class="mode-hint lato-12-n-vw">Removes the field and every value already entered
            on existing risks.</span>
        </span>
      </label>

      <label class="mode-option">
        <input type="radio" name="deleteMode" [value]="deleteModes.NEW_RISKS_ONLY"
          [(ngModel)]="mode" />
        <span class="mode-text">
          <span class="mode-title lato-14-n-vw txt-clr">Delete from new risks only</span>
          <span class="mode-hint lato-12-n-vw">Existing risks keep the field and their
            values.</span>
        </span>
      </label>
    </div>

    <div class="confirm-row">
      <span class="lato-14-b-vw txt-clr">Type the word</span>
      <span class="confirm-word lato-14-b-vw">"confirm"</span>
      <span class="lato-14-b-vw txt-clr">to delete</span>
      <input class="confirm-input lato-14-n-vw" type="text" name="deleteConfirmation"
        aria-label="Type confirm to delete" placeholder="confirm" autocomplete="off"
        [(ngModel)]="confirmationText" (keydown.enter)="onConfirm(); $event.preventDefault()" />
    </div>

    <div class="dialog-actions">
      <button class="action-btn action-btn--confirm lato-14-n-vw" type="button"
        [disabled]="!canConfirm" (click)="onConfirm()">CONFIRM</button>
      <button class="action-btn action-btn--cancel lato-14-n-vw" type="button"
        [disabled]="isDeleting" (click)="onCancel()">CANCEL</button>
    </div>
  </div>
</div>
